"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineClassifierEntity = defineClassifierEntity;
const saveClassifierPublicData_1 = require("../utils/saveClassifierPublicData");
function defineClassifierEntity(classifier, dataSchema) {
    const onScheduleChangedAsync = (context, params) => {
        const actionParams = params.actionParams;
        return (!actionParams?.internal && !!classifier.publicData) || !!classifier.entity.onScheduleChangedAsync?.(context, params);
    };
    const onChangedAsync = (context, params) => {
        if (classifier.publicData === true) {
            (0, saveClassifierPublicData_1.saveClassifierPublicData)(context, { entityName: params.entity }, true);
        }
        else if (Array.isArray(classifier.publicData)) {
            for (const savePublicDataParams of classifier.publicData) {
                (0, saveClassifierPublicData_1.saveClassifierPublicData)(context, { ...savePublicDataParams, entityName: params.entity }, true);
            }
        }
        else if (typeof classifier.publicData === 'function') {
            classifier.publicData(context.storage(params.entity), context.publicData, true);
        }
        classifier.entity.onChangedAsync?.(context, params);
    };
    const classifierDef = {
        ...classifier,
        entity: {
            audit: {
                columnForAuditIdReplacement: 'name',
            },
            ...classifier.entity,
            onScheduleChangedAsync,
            onChangedAsync,
        },
    };
    if (dataSchema) {
        const validatedDef = {
            ...classifierDef,
            entity: {
                ...classifierDef.entity,
                onAuthPost: (appState, userState, params, context) => {
                    if (params.action === 'create' || params.action === 'update') {
                        const validationResult = dataSchema.safeParse(params.data, {});
                        if (!validationResult.success) {
                            throw new Error(validationResult.error.issues.map((issue) => issue.message).join('; '));
                        }
                    }
                    return classifierDef.entity.onAuthPost?.(appState, userState, params, context);
                },
            },
        };
        if (classifierDef.entity.onAnonymousAuthPostCreate) {
            validatedDef.entity.onAnonymousAuthPostCreate = (appState, params, validationContext) => {
                const validationResult = dataSchema.safeParse(params.data);
                if (!validationResult.success) {
                    throw new Error(validationResult.error.issues.map((issue) => issue.message).join('; '));
                }
                return classifierDef.entity.onAnonymousAuthPostCreate?.(appState, params, validationContext);
            };
        }
        return validatedDef;
    }
    return classifierDef;
}
